(() => {
  const frame = document.querySelector('[data-browsstamp-player]');
  if (!frame) return;
  const video = frame.querySelector('video[data-browsstamp-video]');
  const poster = frame.querySelector('[data-video-poster]');
  const toggle = frame.querySelector('[data-video-toggle]');
  const sound = frame.querySelector('[data-video-sound]');
  const error = frame.querySelector('[data-video-error]');
  const slide = frame.closest('.product__media-item');
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  let visible = false;
  let manualPause = false;
  let manualStart = false;
  let pending = false;
  video.muted = true;
  video.defaultMuted = true;
  const eligible = () => visible && !document.hidden && !slide.hidden && !manualPause &&
    (manualStart || (!reduced.matches && !navigator.connection?.saveData));
  const labels = () => {
    toggle.setAttribute('aria-label', video.paused ? toggle.dataset.playLabel : toggle.dataset.pauseLabel);
    toggle.querySelector('[data-play-icon]').textContent = video.paused ? '▶' : 'Ⅱ';
    sound.setAttribute('aria-label', video.muted ? sound.dataset.unmuteLabel : sound.dataset.muteLabel);
    sound.setAttribute('aria-pressed', String(!video.muted));
    sound.querySelector('.browsstamp-sound-slash').hidden = !video.muted;
  };
  const play = () => {
    if (!eligible() || pending || !video.paused) return;
    if (!video.getAttribute('src')) {
      video.src = video.dataset.src;
      video.preload = 'metadata';
    }
    pending = true;
    video.play().then(() => {
      pending = false;
      if (!eligible()) video.pause();
      labels();
    }).catch(() => { pending = false; labels(); });
  };
  const sync = () => {
    if (eligible()) play();
    else video.pause();
    labels();
  };
  new IntersectionObserver(entries => {
    const entry = entries[0];
    visible = entry.isIntersecting && entry.intersectionRatio >= 0.2;
    sync();
  }, { threshold:[0, 0.2, 0.5, 1] }).observe(video);
  new MutationObserver(sync).observe(slide, { attributes:true, attributeFilter:['hidden','class'] });
  [toggle, sound].forEach(button => {
    button.addEventListener('pointerdown', event => event.stopPropagation());
    button.addEventListener('pointerup', event => event.stopPropagation());
  });
  toggle.addEventListener('click', () => {
    if (!video.paused) { manualPause = true; video.pause(); }
    else { manualPause = false; manualStart = true; error.hidden = true; play(); }
    labels();
  });
  sound.addEventListener('click', () => {
    video.muted = !video.muted;
    if (!video.muted && video.paused) { manualPause = false; manualStart = true; play(); }
    labels();
  });
  video.addEventListener('playing', () => { poster.hidden = true; error.hidden = true; labels(); });
  video.addEventListener('pause', labels);
  video.addEventListener('volumechange', labels);
  video.addEventListener('error', () => { error.hidden = false; poster.hidden = false; labels(); });
  document.addEventListener('visibilitychange', sync);
  window.addEventListener('pagehide', () => video.pause());
  window.addEventListener('pageshow', sync);
  reduced.addEventListener('change', sync);
  labels();
})();
